import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeSection = ({ selectedClient }) => {
  const currentDate = new Date()?.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="bg-gradient-to-br from-primary/5 via-accent/5 to-primary/10 rounded-xl p-8 mb-6 border border-primary/10">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h1 className="text-3xl font-semibold text-foreground mb-2">
            Welcome to Admin Portal
          </h1>
          <p className="text-muted-foreground flex items-center gap-2">
            <Icon name="Calendar" size={16} />
            {currentDate}
          </p>
        </div>
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="Shield" size={32} color="var(--color-primary)" />
        </div>
      </div>
      {selectedClient ? (
        <div className="mt-6 p-4 bg-background rounded-lg border border-border">
          <div className="flex items-center gap-3 mb-2">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
            <span className="text-sm font-medium text-success">Currently Managing</span>
          </div>
          <div className="flex items-center gap-4 ml-8 mt-2">
            {selectedClient.image && (
              <img
                src={selectedClient.image}
                alt={selectedClient.name}
                className="w-16 h-16 rounded-full object-cover border border-border"
              />
            )}
            <div>
              <p className="text-lg font-semibold text-foreground">{selectedClient?.name}</p>
              <p className="text-sm text-muted-foreground">{selectedClient?.company}</p>
              <p className="text-xs text-muted-foreground font-mono mt-1">{selectedClient?.id}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-6 p-4 bg-warning/5 rounded-lg border border-warning/20">
          <div className="flex items-center gap-3">
            <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
            <p className="text-sm text-muted-foreground">
              Please select a client from the sidebar to begin managing inventory
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomeSection;